export default {"src":"https://fishbrain.com/_next/static/media/washington.73327920.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};